import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  mobileCompleteMessage:
    'That’s all we need. You can submit your verification now.',
  mobileCompleteButtonText: 'Submit verification',
})
